var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 180,
        width: 800,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          rx: "1",
          height: "25",
          width: "767",
          y: "17.45313",
          x: "17.5",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "1",
          height: "114",
          width: "183",
          y: "53.45313",
          x: "17.5",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "1", height: "15", width: "261", y: "55.45313", x: "314" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "1",
          height: "15",
          width: "176",
          y: "78.45313",
          x: "356.5",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "1",
          height: "15",
          width: "279",
          y: "101.45313",
          x: "305",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "1",
          height: "25",
          width: "142",
          y: "142.45313",
          x: "373.5",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }